<div class="json-mapping-container">
  <div class="json-mapping-container__header">
    <div class="json-mapping-container__header-title">{{ title }}</div>
    <div class="close-icon">
      <img alt="" (click)="onCloseHandler()" src="../.././../../../assets/icons/x-delivery-services.svg" />
    </div>
  </div>

  <div class="content">
    @for (row of rows; track row; let i = $index) {
    <div class="row">
      <div>
        <pdq-input
          [(ngModel)]="row.key"
          [placeholder]="newKeyPlaceholder"
          [matTooltip]="row.key"
          matTooltipClass="pdq-mat-tooltip"
          matTooltipPosition="above"></pdq-input>
      </div>
      <div>
        <ng-select
          class="form-input select-field"
          [ngClass]="{ 'small': additionalValueOptions.length }"
          [(ngModel)]="row.value"
          [matTooltip]="getOptionNameByValue(row.value)"
          matTooltipClass="pdq-mat-tooltip"
          matTooltipPosition="above">
          @for (option of options; track option) {
          <ng-option [value]="option.value"
            ><span class="select-option" [title]="option.name">{{option.name}}</span></ng-option
          >
          }
        </ng-select>
      </div>
      @if (additionalValueOptions.length) {
      <div>
        <ng-select
          class="form-input select-field additional-value-select"
          [(ngModel)]="row.additionalValue"
          [matTooltip]="row.additionalValue"
          matTooltipClass="pdq-mat-tooltip"
          matTooltipPosition="above">
          @for (additionalValueOption of additionalValueOptions; track additionalValueOption) {
          <ng-option [value]="additionalValueOption.value"
            ><span class="select-option" [title]="additionalValueOption.name"
              >{{additionalValueOption.name}}</span
            ></ng-option
          >
          }
        </ng-select>
      </div>
      }
      <button
        mat-flat-button
        class="add-btn"
        (click)="onDeleteHandler(i)"
        matTooltip="Delete mapping"
        matTooltipClass="pdq-mat-tooltip"
        matTooltipPosition="above">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    }

    <h3>Add new</h3>

    <div class="row">
      <div>
        <pdq-input
          [ngClass]="{ 'invalid-input': showNewKeyRequiredError }"
          [(ngModel)]="newKey"
          [placeholder]="newKeyPlaceholder"
          [matTooltip]="newKey"
          matTooltipClass="pdq-mat-tooltip"
          matTooltipPosition="above"></pdq-input>
        @if (showNewKeyRequiredError) {
        <div class="error-message">* Required field</div>
        }
      </div>
      <div>
        <ng-select
          class="form-input select-field"
          [ngClass]="{ 'small': additionalValueOptions.length }"
          [(ngModel)]="newValue"
          [matTooltip]="getOptionNameByValue(newValue)"
          matTooltipClass="pdq-mat-tooltip"
          matTooltipPosition="above"
          [addTag]="freeTextSupport && addCustomOption"
          addTagText="Add option">
          @for (option of options; track option) {
          <ng-option [value]="option.value"
            ><span class="select-option" [title]="option.name">{{option.name}}</span></ng-option
          >
          }
        </ng-select>
      </div>
      @if (additionalValueOptions.length) {
      <div>
        <ng-select
          class="form-input select-field additional-value-select"
          [(ngModel)]="additionalValue"
          [matTooltip]="additionalValue"
          matTooltipClass="pdq-mat-tooltip"
          matTooltipPosition="above">
          @for (additionalValueOption of additionalValueOptions; track additionalValueOption) {
          <ng-option [value]="additionalValueOption.value"
            ><span class="select-option" [title]="additionalValueOption.name"
              >{{additionalValueOption.name}}</span
            ></ng-option
          >
          }
        </ng-select>
      </div>
      }
      <button
        mat-flat-button
        class="add-btn"
        (click)="onAddHandler()"
        matTooltip="Add mapping"
        matTooltipClass="pdq-mat-tooltip"
        matTooltipPosition="above">
        <mat-icon>add_task</mat-icon>
      </button>
    </div>

    @if (defaultMappings.length) {
    <h3>Default mappings</h3>
    } @for (defaultMapping of defaultMappings; track defaultMapping; let i = $index) {
    <div class="row">
      <div>
        <pdq-input
          [(ngModel)]="defaultMapping.key"
          readonly="true"
          [matTooltip]="defaultMapping.key"
          matTooltipClass="pdq-mat-tooltip"
          matTooltipPosition="above"></pdq-input>
      </div>
      <div>
        <ng-select
          class="form-input select-field"
          [ngClass]="{ 'small': additionalValueOptions.length }"
          [(ngModel)]="defaultMapping.value"
          [matTooltip]="getOptionNameByValue(defaultMapping.value)"
          matTooltipClass="pdq-mat-tooltip"
          matTooltipPosition="above">
          @for (option of options; track option) {
          <ng-option [value]="option.value"
            ><span class="select-option" [title]="option.name">{{option.name}}</span></ng-option
          >
          }
        </ng-select>
      </div>
      @if (additionalValueOptions.length) {
      <div>
        <ng-select
          class="form-input select-field additional-value-select"
          [(ngModel)]="defaultMapping.additionalValue"
          [matTooltip]="defaultMapping.additionalValue"
          matTooltipClass="pdq-mat-tooltip"
          matTooltipPosition="above">
          @for (additionalValueOption of additionalValueOptions; track additionalValueOption) {
          <ng-option [value]="additionalValueOption.value"
            ><span class="select-option" [title]="additionalValueOption.name"
              >{{additionalValueOption.name}}</span
            ></ng-option
          >
          }
        </ng-select>
      </div>
      }
      <!-- <button title="Delete" mat-flat-button class="add-btn" (click)="onDeleteDefaultMappingHandler(i)">
                    <mat-icon>delete</mat-icon>
                  </button> -->
    </div>
    }
  </div>

  <div class="json-mapping-container__actions">
    <button mat-flat-button class="json-mapping-container__actions-deletebtn" (click)="onSaveHandler()">Save</button>
    <button mat-flat-button class="json-mapping-container__actions-cancelbtn" (click)="onCloseHandler()">Cancel</button>
  </div>
</div>
